function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9998 25.7374L30.1266 27.6246L29.2968 24.0678L32.0593 21.6747L28.4215 21.3661L26.9998 18.0116L25.5781 21.3661L21.9404 21.6747L24.7028 24.0678L23.8731 27.6246L26.9998 25.7374Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9031 46.2137V45.3006H20.8071V40.2298H20.7293L19.1557 41.9104L18.4854 41.3081L20.2145 39.4333H21.8853V45.3006H23.5367V46.2137H18.9031ZM24.7569 46.2137V39.4333H28.9923V40.4047H25.8546V42.2892H28.6426V43.2606H25.8546V46.2137H24.7569ZM33.9833 46.2137L33.3713 44.3778H30.8359L30.2434 46.2137H29.1262L31.4382 39.4333H32.8176L35.1296 46.2137H33.9833ZM32.1279 40.4435H32.0793L31.0982 43.4355H33.0993L32.1279 40.4435Z",
  fill: "current"
});

function SvgFa1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa1);
export default __webpack_public_path__ + "static/media/fa1.431c16e8.svg";
export { ForwardRef as ReactComponent };